import { render, staticRenderFns } from "./DialogProductDataInput.vue?vue&type=template&id=e1ec96ce&scoped=true&"
import script from "./DialogProductDataInput.vue?vue&type=script&lang=js&"
export * from "./DialogProductDataInput.vue?vue&type=script&lang=js&"
import style0 from "./DialogProductDataInput.vue?vue&type=style&index=0&id=e1ec96ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ec96ce",
  null
  
)

export default component.exports